// extracted by mini-css-extract-plugin
export default {"wrapper":"cartEmpty_wrapper__Aj4TC"};